import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { RevealLines } from "@/components/Reveal";

const Shop = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "";

  useEffect(() => {
    setLoading(true);
    const q = category ? { category } : {};
    api.get("/products", { params: q }).then(({ data }) => {
      setProducts(data);
      setLoading(false);
    });
  }, [category]);

  const filters = [
    { label: "All", value: "" },
    { label: "Kurtis", value: "Kurti" },
    { label: "Suits", value: "Suit" },
  ];

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-24">
      <div className="mb-14">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8C3A3A] mb-5">The Collection</p>
        <h1 className="font-serif font-light text-6xl md:text-8xl tracking-tight text-[#1A1A1A] leading-[0.9]">
          <RevealLines lines={[category === "Suit" ? "Suits" : category === "Kurti" ? "Kurtis" : "Everything"]} />
        </h1>
      </div>

      <div className="flex items-center gap-3 mb-14 border-b border-[#E5E1D8] pb-6">
        {filters.map((f) => (
          <button
            key={f.label}
            data-testid={`filter-${f.label.toLowerCase()}`}
            onClick={() => setParams(f.value ? { category: f.value } : {})}
            className={`font-mono text-[11px] uppercase tracking-[0.18em] px-4 py-2 transition-colors duration-300 ${
              category === f.value ? "bg-[#1A1A1A] text-[#F9F8F6]" : "text-[#595959] hover:text-[#8C3A3A]"
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#595959]">Loading…</p>
      ) : products.length === 0 ? (
        <p className="font-serif text-3xl text-[#595959]">No pieces here yet.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-16" data-testid="product-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
};

export default Shop;
